import { useCallback, useEffect, useMemo, useState } from 'react'
import Supercluster from 'supercluster'
import { useMapViewport } from './use-viewport'

export function useSupercluster(data, superclusterOptions, defaultBounds, defaultZoom) {
    const clusterer = useMemo(() => {
        return new Supercluster(superclusterOptions)
    }, [superclusterOptions])

    const [version, setVersion] = useState(0)

    useEffect(() => {
        clusterer.load(data)
        setVersion((x) => x + 1)
    }, [clusterer, data])

    const { bbox, zoom } = useMapViewport({ padding: 100 })

    const clusters = useMemo(() => {
        if (!clusterer || version === 0) return []
        return  clusterer && clusterer?.points && bbox && zoom ? clusterer?.getClusters(bbox, zoom) : []
    }, [version, clusterer, bbox, zoom, data])

    const getChildren = useCallback(
        (clusterId) => clusterer.getChildren(clusterId),
        [clusterer]
    )

    const getLeaves = useCallback(
        (clusterId) => clusterer.getLeaves(clusterId, Infinity),
        [clusterer]
    )

    const getClusterExpansionZoom = useCallback(
        (clusterId) => clusterer.getClusterExpansionZoom(clusterId),
        [clusterer]
    )

    return {
        clusters,
        getChildren,
        getLeaves,
        getClusterExpansionZoom
    }
}
